import Axios, { AxiosResponse } from 'axios';
import ApiMock from './mock/ApiMock';
import UserForm from './models/UserForm';
import InvoiceForm from './models/InvoiceForm';

export type RequestMethod =
  | 'GET'
  | 'POST'
  | 'PUT'
  | 'PATCH'
  | 'DELETE'
  | 'HEAD'
  | 'OPTIONS'
  | 'LINK'
  | 'UNLINK';

export default class ApiRequest {
  private static baseUrl: string =
    process.env.NODE_ENV === 'production'
      ? 'https://2021.fanaticosnortox.com.br/api/v1/'
      : 'https://2021.fanaticosnortox.com.br/api/v1/';
  // : 'http://localhost:8999/api/v1/';

  private static getToken(): string {
    return localStorage.getItem('nortox-api-token') || '';
  }

  private static request(method: RequestMethod, route: string, data?: any): Promise<AxiosResponse> {
    if (process.env.NODE_ENV !== 'test') {
      const token = ApiRequest.getToken();
      let headers = {};

      if (token !== '') {
        headers = { Authorization: `Bearer ${token}` };
      }

      return Axios({
        method,
        url: ApiRequest.baseUrl + route,
        data: data,
        headers,
      });
    } else {
      return ApiMock(method, route, data);
    }
  }

  public static login(userData: { username: string; password: string }): Promise<AxiosResponse> {
    return ApiRequest.request('POST', 'bearer', userData);
  }

  public static checkZipcode(zipcode: string): Promise<AxiosResponse> {
    return ApiRequest.request('GET', `search/zipcode?zipcode=${zipcode}`);
  }

  public static register(data: UserForm): Promise<AxiosResponse> {
    return ApiRequest.request('POST', 'client', data);
  }

  public static updateProfile(data: UserForm): Promise<AxiosResponse> {
    return ApiRequest.request('PUT', 'client', data);
  }

  public static changePassword(data: {
    'current-password': string;
    password: string;
    'confirm-password': string;
  }): Promise<AxiosResponse> {
    return ApiRequest.request('POST', 'client/change-password', data);
  }

  public static getUser(): Promise<AxiosResponse> {
    return ApiRequest.request('GET', 'client');
  }

  public static getProducts(): Promise<AxiosResponse> {
    return ApiRequest.request('GET', 'search/products');
  }

  public static getDistributors(): Promise<AxiosResponse> {
    return ApiRequest.request('GET', 'search/distributor');
  }

  public static registerInvoice(data: InvoiceForm): Promise<AxiosResponse> {
    return ApiRequest.request('POST', 'invoice', data);
  }

  public static uploadInvoicePhoto(id: number, data: FormData): Promise<AxiosResponse> {
    return ApiRequest.request('POST', `invoice/upload/${id}`, data);
  }

  public static getInvoiceList(): Promise<AxiosResponse> {
    return ApiRequest.request('GET', 'client/invoices');
  }

  public static getLuckyNumbers(): Promise<AxiosResponse> {
    return ApiRequest.request('GET', 'client/lucky-numbers');
  }

  public static luckySpin(): Promise<AxiosResponse> {
    return ApiRequest.request('GET', 'lucky');
  }

  public static getWinners(): Promise<AxiosResponse> {
    return ApiRequest.request('GET', 'lottery/winners');
  }

  public static passwordReset(data: string): Promise<AxiosResponse> {
    return ApiRequest.request('POST', 'client/password-reset', { email: data });
  }

  public static myGifts(): Promise<AxiosResponse> {
    return ApiRequest.request('GET', 'client/my-gifts');
  }
}
